import PaymentSuccessModal from "@/Components/User/Modal/PaymentSuccessModal";
import { decryptInteger } from "@/Utils/encryptInteger";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";

export default function PaymentSuccessPage() {
    const router = useRouter();
    const [stripePromise, setStripePromise] = useState(null);
    const [paymentData, setPaymentData] = useState(null);

    useEffect(() => {
        // Store last_url if user is not logged in (for redirect after login)
        try {
            const userData = localStorage.getItem("user_data");
            if (!userData) {
                sessionStorage.setItem("last_url", window.location.pathname + window.location.search);
            }
        } catch (error) {
            console.error("Error storing last_url:", error);
        }

        try {
            const decryptedData = decryptInteger(localStorage.getItem("payment_data"));
            setPaymentData(JSON.parse(decryptedData));
        } catch (error) {
            console.error("Error retrieving payment data:", error);
        }
    }, []);

    useEffect(() => {
        if (paymentData?.publishableKey) {
            loadStripe(paymentData.publishableKey).then(setStripePromise);
        }
    }, [paymentData]);

    const options = {
        clientSecret: paymentData?.paymentIntent,
        appearance: {
            theme: "night",
            variables: {
                colorPrimary: "#FA2CB4",
                colorBackground: "#0D0C0F",
                colorText: "#FFFFFF",
                colorDanger: "#ff3860",
                borderRadius: "8px",
            },
        },
    };

    return (
        <Elements stripe={stripePromise} options={options}>
            <PaymentSuccessModal />
        </Elements>
    );
}
